// export default async function InsertProject(senddata) {
//     let url = window.RealestateService + "/api/Project/InsertProject"
//     let response = {}

//     let head = {
//         "Content-Type": "application/json",
//         'accept': '*/*'
//     }
//     response = await fetch(url, {
//         method: "POST",
//         headers: head,
//         body: senddata
//     }).then(res => res.json()).then(response)
//     return response;
// }

export default async function InsertProject(senddata) {

    let url = window.RealestateService + "/api/Project/InsertProject"

    try {

        let response = await fetch(url, {
            method: "POST",
            headers: {
                accept: "*/*"
            },
            body: senddata
        })

        let data = await response.json()

        return data

    } catch (error) {

        console.log("InsertProject Error", error)

        return {
            status: 0,
            responseValue: "Something went wrong"
        }
    }
}